import $ from 'jquery';

export default () => {
    $('.ticker-pause-js').on('click', function () {
        $(this).parents('.ticker-block').toggleClass('ticker-animation--paused');
        $(this).find('.ticker-button__icon').toggleClass('ticker-button__icon--hidden');
        $(this).children('.ticker-button__label').toggleClass('ticker-button__label--hidden');
    });
};
